var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wf-modal",
      class: "wf-modal-" + (_vm.open ? "active" : "inactive")
    },
    [
      _vm.open
        ? _c(
            "div",
            { staticClass: "wf-modal-wrapper wf-modal-wrapper-video" },
            [
              _vm.videoType == "youtube"
                ? [
                    _c("iframe", {
                      staticClass: "wf-modal-video",
                      attrs: {
                        frameborder: "0",
                        allow:
                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                        allowfullscreen: "",
                        src:
                          "https://www.youtube.com/embed/" +
                          _vm.videoData +
                          "?autoplay=1"
                      }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.videoType == "element"
                ? [
                    _c(
                      "video",
                      {
                        staticClass: "video w-100",
                        attrs: { controls: "", autoplay: "" }
                      },
                      [
                        _c("source", {
                          attrs: { type: "video/mp4", src: _vm.videoData }
                        })
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "wf-modal-button-close btn button-full",
                  attrs: { type: "button" },
                  on: { click: _vm.close }
                },
                [
                  _c("span", {
                    staticClass: "png-icon png-icon-icons-symbols--k-txtclose ",
                    attrs: { "aria-label": "Close modal" }
                  })
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "wf-modal-lightbox", on: { click: _vm.close } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }